import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { withMenu } from '../../../containers/Menus';
import withMenuModals from '../../../containers/Modals/menu';

class DisabledMenuModal extends Component {
  disableMenu = () => {
    this.props.publishMenu(false, {
      id: this.props.modal.publishMenu.id,
      merchantId: this.props.modal.publishMenu.merchantId,
    });
  };

  componentDidUpdate() {
    const { isPublishMenuFinished, finishPublishMenu, closeModal } = this.props;
    if (isPublishMenuFinished) {
      finishPublishMenu();
      closeModal();
    }
  }

  render() {
    const { modal, container, closeModal } = this.props;
    return (
      <Modal
        show={modal.showDisabledMenuModal}
        container={container}
        className="newMenuModal menu-modal"
        onHide={closeModal}
      >
        <Modal.Header closeButton>
          <div className="icon" />
          <Modal.Title>ocultar cardápio</Modal.Title>
          <p className="subtitle">Tem certeza que deseja ocultar o cardápio para os usuários?</p>
        </Modal.Header>
        <Modal.Body className="modal-body-sm">
          <div className="divisor" />
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-group">
            <Button className="cancel" id="cancelMenu" onClick={closeModal}>
              Cancelar
            </Button>
            <Button className="confirm" id="confirmMenu" onClick={this.disableMenu}>
              Ocultar
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

DisabledMenuModal.propTypes = {
  container: PropTypes.object,
};

export default withMenu(withMenuModals(DisabledMenuModal));



// WEBPACK FOOTER //
// ./src/components/GenericModal/DisabledMenuModal/index.js